import Web3 from "web3";

let provider: Web3;

export async function getProvider(): Promise<Web3> {
    if (provider) return provider;
    provider = new Web3(window.ethereum);
    return provider;
};